import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Facebook = ({ width }) => (
  <svg width={width} height={width} viewBox="299 22 16 16">
    <path
      d="M299,25.0094776 C299,23.347389 300.336631,22 302.009478,22 L311.990522,22 C313.652611,22 315,23.3366311 315,25.0094776 L315,34.9905224 C315,36.652611 313.663369,38 311.990522,38 L302.009478,38 C300.347389,38 299,36.6633689 299,34.9905224 L299,25.0094776 Z M310.03529,38 L310.03529,31.8064419 L312.114271,31.8064419 L312.425522,29.3926592 L310.03529,29.3926592 L310.03529,27.8515655 C310.03529,27.1527191 310.229327,26.6764345 311.231515,26.6764345 L312.509717,26.6758951 L312.509717,24.5170337 C312.288593,24.4876704 311.529882,24.4219326 310.647185,24.4219326 C308.804309,24.4219326 307.542706,25.5467865 307.542706,27.6125843 L307.542706,29.3926592 L305.458451,29.3926592 L305.458451,31.8064419 L307.542706,31.8064419 L307.542706,38 L310.03529,38 Z"
      stroke="none"
      fill={OSLO_GRAY}
      fillRule="evenodd"
    />
  </svg>
);

Facebook.propTypes = {
  width: PropTypes.number,
};

Facebook.defaultProps = {
  width: 20,
};

export default Facebook;
